import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { SezioneContropartiResponse } from 'src/app/common/models/dto/sezione-controparti-response';
import { FascicoloFull } from 'src/app/common/models/fascicolo/fascicolo-full';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { EsitiDatiGeneraliForm } from '../../../form/esiti-dati-generali-form';
import { SezioneEsitiResponse } from '../../../models/dto/sezione-esiti-response';
import { Esito } from '../../../models/esito';
import { SezioneEsitiFull } from '../../../models/sezioni/sezione-esiti-full';
import { FormValidationService } from '../../../services/form-validation.service';
import { SezioneAltrePartiResponse } from 'src/app/common/models/dto/sezione-altre-parti-response';
import { SezioneLegaliResponse } from 'src/app/common/models/dto/sezione-legali-response';

@Component({
    selector: 'div [esiti-dati-generali-update-form]',
  templateUrl: '../../../form/esiti-dati-generali-form.html',
  host: { '[class.col-sm-12]': '\'true\'', '[class.coldx]': '\'true\'' }
})

export class EsitiDatiGeneraliComponent extends EsitiDatiGeneraliForm implements OnInit {

  @Output() onReturn: EventEmitter<SezioneEsitiFull> = new EventEmitter<SezioneEsitiFull>();
  @Output() esitoMod: EventEmitter<Esito> = new EventEmitter<Esito>();

  private idSezione: string;
  private esito: Esito;
  private updateUrl: string;

  constructor(@Inject(HelpersService) helpers: HelpersService, @Inject(OperationsService) operations: OperationsService, @Inject(FormBuilder) campiForm: FormBuilder, @Inject(FormValidationService) formValidationService: FormValidationService) {
    super(helpers, operations, campiForm, formValidationService);
  }

  ngOnInit() {
    this.setTitle('Modifica dati');
    this.isInserimento(false);
  }

  getRequest(request: Esito) {
    this.operations.setEsitoInSezesiti(this.updateUrl, this.idSezione, request).subscribe(response => this.returnSetSezEsitiOrdinario(response));
  }

  returnSetSezEsitiOrdinario(response: SezioneEsitiResponse) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
      this.esitoMod.emit(this.request)
    }
  }

  readSezioneControparti(idSezione, url){
    if(idSezione){
      this.operations.readSezione(url, idSezione).subscribe(response=>{
        this.contropartiOptions=(<SezioneContropartiResponse>response).sezione.controparti;
      });
    }
  }

  readSezioneAltreParti(idSezione, url) {
    if (idSezione) {
      this.operations.readSezione(url, idSezione).subscribe(response => {
        this.altrePartiOptions = (<SezioneAltrePartiResponse>response).sezione.altreParti;
      });
    }
  }
  readSezioneLegali(idSezione, url) {
    if (idSezione) {
      this.operations.readSezione(url, idSezione).subscribe(response => {
        this.legaliOptions = (<SezioneLegaliResponse>response).sezione.legaliIncaricati;
      });
    }
  }

  inizializza(updateUrl: string, esito: Esito, idSezione: string, fascicolo: FascicoloFull, urlReadSezioneControparti: string,urlReadSezioneAltreParti: string, urlReadSezioneLegali: string) {
    this.esito = esito;
    this.idSezione = idSezione;
    this.updateUrl = updateUrl;
    this.fascicolo = fascicolo;
        //this.readClassificazioni(fascicolo.praticaBase.id);

    this.readSezioneControparti(fascicolo.idSezioneControparti, urlReadSezioneControparti);
    this.readSezioneAltreParti(fascicolo.idSezioneAltreParti, urlReadSezioneAltreParti);
    this.readSezioneLegali(fascicolo.idSezioneLegali, urlReadSezioneLegali);
    this.createForm();
    this.populateSelect();
  }

  getEsito(): Esito {
    return this.esito;
  }
}
